import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ICSAProductContextFacade } from 'dias-core/facades/icsa-product-context.facade';
import { Observable } from 'rxjs';

@Component({
  selector: 'custom-product-marketing-label',
  templateUrl: './product-marketing-label.component.html',
  providers: [ICSAProductContextFacade],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class ProductMarketingLabelComponent implements OnInit {
  private context = inject(ICSAProductContextFacade);

  labels$: Observable<string[]>;

  ngOnInit(): void {
    this.labels$ = this.context.getMarketingLabels$();
  }
}
